//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './CustomersClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type GetMyCustomerInfoCustomersQueryParameters = {
  language?: string | undefined ;
}

export function getMyCustomerInfoUrl(language?: string | undefined): string {
  let url_ = getBaseUrl() + "/api/customers/me?";
if (language === null)
    throw new Error("The parameter 'language' cannot be null.");
else if (language !== undefined)
    url_ += "language=" + encodeURIComponent("" + language) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getMyCustomerInfoDefaultOptions: Omit<UseQueryOptions<Types.CustomerInfoDto, unknown, Types.CustomerInfoDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.CustomerInfoDto, unknown, Types.CustomerInfoDto>, 'queryFn'>> = {
};
export function getGetMyCustomerInfoDefaultOptions() {
  return getMyCustomerInfoDefaultOptions;
};
export function setGetMyCustomerInfoDefaultOptions(options: typeof getMyCustomerInfoDefaultOptions) {
  getMyCustomerInfoDefaultOptions = options;
}

export function getMyCustomerInfoQueryKey(language?: string | undefined): QueryKey;
export function getMyCustomerInfoQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { language,  } = params[0] as GetMyCustomerInfoCustomersQueryParameters;

    return trimArrayEnd([
        'CustomersClient',
        'getMyCustomerInfo',
        language as any,
      ]);
  } else {
    return trimArrayEnd([
        'CustomersClient',
        'getMyCustomerInfo',
        ...params
      ]);
  }
}
export function __getMyCustomerInfo(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getMyCustomerInfo(
      context.queryKey[2] as string | undefined,axiosConfig    );
}

export function useGetMyCustomerInfoQuery<TSelectData = Types.CustomerInfoDto, TError = unknown>(dto: GetMyCustomerInfoCustomersQueryParameters, options?: Omit<UseQueryOptions<Types.CustomerInfoDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Get current user's customer information from Abas
 * @param language (optional) 
 */
export function useGetMyCustomerInfoQuery<TSelectData = Types.CustomerInfoDto, TError = unknown>(language?: string | undefined, options?: Omit<UseQueryOptions<Types.CustomerInfoDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetMyCustomerInfoQuery<TSelectData = Types.CustomerInfoDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.CustomerInfoDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let language: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ language,  } = params[0] as GetMyCustomerInfoCustomersQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [language, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.CustomerInfoDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getMyCustomerInfo(context, axiosConfig) : __getMyCustomerInfo,
    queryKey: getMyCustomerInfoQueryKey(language),
    ...getMyCustomerInfoDefaultOptions as unknown as Omit<UseQueryOptions<Types.CustomerInfoDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Get current user's customer information from Abas
 * @param language (optional) 
 */
export function setGetMyCustomerInfoData(queryClient: QueryClient, updater: (data: Types.CustomerInfoDto | undefined) => Types.CustomerInfoDto, language?: string | undefined) {
  queryClient.setQueryData(getMyCustomerInfoQueryKey(language),
    updater
  );
}

/**
 * Get current user's customer information from Abas
 * @param language (optional) 
 */
export function setGetMyCustomerInfoDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.CustomerInfoDto | undefined) => Types.CustomerInfoDto) {
  queryClient.setQueryData(queryKey, updater);
}